// import Plotly from 'plotly.js-basic-dist';
// import createPlotlyComponent from 'react-plotly.js/factory';
// // const Plotly = window.Plotly

// // config options plotly
// // https://github.com/plotly/plotly.js/blob/master/src/fonts/ploticon.js

// const Plot = createPlotlyComponent(Plotly);
// export default Plot;



import React, { lazy, Suspense } from 'react';

// Dynamically import Plotly.js and create the Plotly component
const LazyPlot = lazy(async () => {
  const Plotly = await import('plotly.js-basic-dist');
  const createPlotlyComponent = await import('react-plotly.js/factory');
  return {
    default: createPlotlyComponent.default(Plotly.default),
  };
});

const Plot = (props) => (
  <Suspense fallback={<div>Loading Plotly chart...</div>}>
    <LazyPlot {...props} />
  </Suspense>
);

export default Plot;
